import PageList from "../abstract/PageList.js";
import GridWrapper from "../../su/GridWrapper.js";
import AgGridWrapper from "../../su/AgGridWrapper.js";

export default class PageMediaList extends PageList {
	constructor() {
		super();
	}


	getAvailableHeight() {
		let a = jQuery(".js-size");
		let i = 0;
		for (let x = 0; x < a.length; x++) {
			i += jQuery(a[x]).outerHeight();
		}
		i += 50; // padding app container
		i += 78; // search box
		i += 143; // paging
		let h = jQuery(window).height() - i;
		return h;
	}

	onAdd() {
		let args = StateManager._splitUrl(document.location.href);
		document.location.href = TheApp.Env.BaseUrlNls + "media/detail?_pi=" + encodeURIComponent(args.qPart["_pi"]);
	}



	initAgList() {
		const rowData = [];
		for (let x = 0; x < this.data.rows.length; x++) {
			const row = this.data.rows[x];
			rowData.push(row);
		}
		this.rowData = rowData;

		const searchBox = document.getElementById("filter-text-box");

		const targetGrid = document.querySelector(".js-aglist");
		const h = this.getAvailableHeight();
		targetGrid.style.height = h + "px";

		const columnDefs = [

			{
				field: "Make",
				headerName: "Marca",
				flex:2,
			},
			{
				field: "Model",
				headerName: "Modello",
			},
			{
				field: "UrlMedia",
				headerName: "Image",
				type: AgGridWrapper.TYPE_IMAGE,
				cellRenderer: params => {
					return `<div class="image grid-list-image"><img src="${params.value}" alt="{MediaCaption}"/></div>`
				}
			},
		];

		// Inizializzazione della griglia (Copia incolla tranne il primo parametro che è un id arbitrario ma usiamo generalmente il nome della pagina)
		let agGrid = new AgGridWrapper("PageMediaList", AgGridWrapper.MODE_SIMPLE);
		const options = agGrid.getConfig({
			paginationPageSize: 20,
			rowHeight: 100,
			onRowClicked: this.onRowClicked.bind(this),
			customOptions: {
				doNotshowSelection: true, // In modo casereccio non mostra la selezione
				removeOldList: true, // Rimuove la vecchia griglia dalla pagina (punta sul fatto che i nodi che la contengono si chiamino "jsList" e "filterbox" grazie al solito copia-incolla selvaggio).
				noRecordsText: "Nessun media trovato.",
			},
			columnDefs,
			rowData,
		});

		// Crea la griglia e ascolta il resize della finestra per cambiare l'altezza
		agGrid.init(targetGrid, searchBox, options);
		window.onresize = this.arrangeGrid.bind(this, agGrid);
	}

	arrangeGrid(agGrid) {
		// Punta alla griglia e ne imposta l'altezza
		const h = this.getAvailableHeight();
		agGrid.targetGrid.style.height = h + "px";
	}

	onRowClicked(params) {
		// Click sulla riga che porta alla pagina di dettaglio
		document.location.href = TheApp.Env.BaseUrlNls + "media/detail/" + Base64.toBase64(params.data.Uid, true) + "?__pi=" + this.data.page.PageId;
	}

}

